<template>
  <div class="detail">
    <sr-loading v-if="loading"/>
    <div v-else>
      <sr-top :data="DATA"/>
      <sr-param :data="DATA"/>
      <sr-content :data="DATA"/>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import SrTop from './sr-top'
  import SrParam from './sr-param'
  import SrContent from './sr-content'
  import SrLoading from '@/components/loading'
  export default {
    components: {
      SrTop,
      SrParam,
      SrContent,
      SrLoading
    },
    data () {
      return {
        loading: true,
        DATA: {}
      }
    },
    methods: {
      selectByUUid () {
        axios.get('/api/productSpuController/selectByUUid', {
          params: {
            id: this.$route.params.id
          }
        }).then(res => {
          if (res.data.code === 9999) {
            this.DATA = res.data.data
            this.loading = false
            document.title = this.DATA.name + ' - 耀莱在线'
          }
        })
      }
    },
    created () {
      this.selectByUUid()
    }
  }
</script>

<style lang="less" scoped>
  .detail {
    width: 1200px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/list-detail/index.vue